<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  show: Boolean
})

const emit = defineEmits(['close'])

const activeTab = ref('balanced-lines') // balanced-lines, milestones

// Sample milestones data
const milestones = ref([
  { id: 89, odds1: 0.00, probability: 0.0, template_id: null, created_at: null, updated_at: null },
  { id: 90, odds1: 0.10, probability: 25.0, template_id: null, created_at: null, updated_at: null },
  { id: 91, odds1: 1.00, probability: 20.0, template_id: null, created_at: null, updated_at: null },
  { id: 92, odds1: 2.00, probability: 15.0, template_id: null, created_at: null, updated_at: null },
  { id: 93, odds1: 3.00, probability: 12.0, template_id: null, created_at: null, updated_at: null },
  { id: 94, odds1: 4.00, probability: 11.0, template_id: null, created_at: null, updated_at: null },
  { id: 95, odds1: 5.00, probability: 10.0, template_id: null, created_at: null, updated_at: null },
  { id: 96, odds1: 6.00, probability: 9.0, template_id: null, created_at: null, updated_at: null },
  { id: 97, odds1: 7.00, probability: 8.0, template_id: null, created_at: null, updated_at: null },
  { id: 98, odds1: 8.00, probability: 7.0, template_id: null, created_at: null, updated_at: null },
  { id: 99, odds1: 9.00, probability: 6.5, template_id: null, created_at: null, updated_at: null },
  { id: 100, odds1: 10.00, probability: 6.25, template_id: null, created_at: null, updated_at: null },
  { id: 101, odds1: 11.00, probability: 6.0, template_id: null, created_at: null, updated_at: null },
  { id: 102, odds1: 12.00, probability: 5.75, template_id: null, created_at: null, updated_at: null },
  { id: 103, odds1: 13.00, probability: 5.5, template_id: null, created_at: null, updated_at: null },
  { id: 104, odds1: 14.00, probability: 5.25, template_id: null, created_at: null, updated_at: null },
  { id: 105, odds1: 15.00, probability: 5.0, template_id: null, created_at: null, updated_at: null },
  { id: 106, odds1: 16.00, probability: 4.75, template_id: null, created_at: null, updated_at: null },
  { id: 107, odds1: 17.00, probability: 4.5, template_id: null, created_at: null, updated_at: null },
  { id: 108, odds1: 18.00, probability: 4.25, template_id: null, created_at: null, updated_at: null },
  { id: 109, odds1: 19.00, probability: 4.0, template_id: null, created_at: null, updated_at: null },
  { id: 110, odds1: 20.00, probability: 3.75, template_id: null, created_at: null, updated_at: null },
  { id: 111, odds1: 21.00, probability: 3.6, template_id: null, created_at: null, updated_at: null },
  { id: 112, odds1: 22.00, probability: 3.5, template_id: null, created_at: null, updated_at: null },
  { id: 113, odds1: 23.00, probability: 3.4, template_id: null, created_at: null, updated_at: null },
  { id: 114, odds1: 24.00, probability: 3.3, template_id: null, created_at: null, updated_at: null },
  { id: 115, odds1: 25.00, probability: 3.2, template_id: null, created_at: null, updated_at: null },
  { id: 116, odds1: 26.00, probability: 3.1, template_id: null, created_at: null, updated_at: null },
  { id: 117, odds1: 27.00, probability: 3.0, template_id: null, created_at: null, updated_at: null },
  { id: 118, odds1: 28.00, probability: 2.9, template_id: null, created_at: null, updated_at: null },
  { id: 119, odds1: 29.00, probability: 2.8, template_id: null, created_at: null, updated_at: null },
  { id: 120, odds1: 30.00, probability: 2.75, template_id: null, created_at: null, updated_at: null },
  { id: 121, odds1: 31.00, probability: 2.7, template_id: null, created_at: null, updated_at: null },
  { id: 122, odds1: 32.00, probability: 2.65, template_id: null, created_at: null, updated_at: null },
  { id: 123, odds1: 33.00, probability: 2.6, template_id: null, created_at: null, updated_at: null },
  { id: 124, odds1: 34.00, probability: 2.5, template_id: null, created_at: null, updated_at: null },
  { id: 125, odds1: 35.00, probability: 2.4, template_id: null, created_at: null, updated_at: null },
  { id: 126, odds1: 36.30, probability: 2.35, template_id: null, created_at: null, updated_at: null },
  { id: 127, odds1: 37.60, probability: 2.3, template_id: null, created_at: null, updated_at: null },
  { id: 128, odds1: 38.80, probability: 2.2, template_id: null, created_at: null, updated_at: null },
  { id: 129, odds1: 40.80, probability: 2.15, template_id: null, created_at: null, updated_at: null },
  { id: 130, odds1: 41.80, probability: 2.1, template_id: null, created_at: null, updated_at: null },
  { id: 131, odds1: 42.70, probability: 2.05, template_id: null, created_at: null, updated_at: null },
  { id: 132, odds1: 43.70, probability: 2.0, template_id: null, created_at: null, updated_at: null },
  { id: 133, odds1: 44.70, probability: 1.96, template_id: null, created_at: null, updated_at: null },
  { id: 134, odds1: 45.80, probability: 1.93, template_id: null, created_at: null, updated_at: null },
  { id: 135, odds1: 46.50, probability: 1.9, template_id: null, created_at: null, updated_at: null },
  { id: 136, odds1: 47.30, probability: 1.87, template_id: null, created_at: null, updated_at: null },
  { id: 137, odds1: 48.20, probability: 1.85, template_id: null, created_at: null, updated_at: null },
  { id: 138, odds1: 49.10, probability: 1.83, template_id: null, created_at: null, updated_at: null },
  { id: 139, odds1: 50.00, probability: 1.8, template_id: null, created_at: null, updated_at: null },
  { id: 140, odds1: 50.90, probability: 1.76, template_id: null, created_at: null, updated_at: null },
  { id: 141, odds1: 51.80, probability: 1.73, template_id: null, created_at: null, updated_at: null },
  { id: 142, odds1: 52.70, probability: 1.7, template_id: null, created_at: null, updated_at: null },
  { id: 143, odds1: 53.50, probability: 1.67, template_id: null, created_at: null, updated_at: null },
  { id: 144, odds1: 54.20, probability: 1.63, template_id: null, created_at: null, updated_at: null },
  { id: 145, odds1: 55.30, probability: 1.6, template_id: null, created_at: null, updated_at: null },
  { id: 146, odds1: 56.30, probability: 1.57, template_id: null, created_at: null, updated_at: null },
  { id: 147, odds1: 57.30, probability: 1.53, template_id: null, created_at: null, updated_at: null },
  { id: 148, odds1: 58.20, probability: 1.5, template_id: null, created_at: null, updated_at: null },
  { id: 149, odds1: 59.20, probability: 1.47, template_id: null, created_at: null, updated_at: null },
  { id: 150, odds1: 61.20, probability: 1.44, template_id: null, created_at: null, updated_at: null },
  { id: 151, odds1: 62.40, probability: 1.4, template_id: null, created_at: null, updated_at: null },
  { id: 152, odds1: 63.70, probability: 1.38, template_id: null, created_at: null, updated_at: null },
  { id: 153, odds1: 64.40, probability: 1.36, template_id: null, created_at: null, updated_at: null },
  { id: 154, odds1: 65.00, probability: 1.34, template_id: null, created_at: null, updated_at: null },
  { id: 155, odds1: 66.00, probability: 1.32, template_id: null, created_at: null, updated_at: null },
  { id: 156, odds1: 67.00, probability: 1.3, template_id: null, created_at: null, updated_at: null },
  { id: 157, odds1: 68.00, probability: 1.28, template_id: null, created_at: null, updated_at: null },
  { id: 158, odds1: 70.00, probability: 1.24, template_id: null, created_at: null, updated_at: null },
  { id: 159, odds1: 71.00, probability: 1.22, template_id: null, created_at: null, updated_at: null },
  { id: 160, odds1: 72.00, probability: 1.2, template_id: null, created_at: null, updated_at: null },
  { id: 161, odds1: 74.00, probability: 1.18, template_id: null, created_at: null, updated_at: null },
  { id: 162, odds1: 76.00, probability: 1.16, template_id: null, created_at: null, updated_at: null },
  { id: 163, odds1: 78.00, probability: 1.14, template_id: null, created_at: null, updated_at: null },
  { id: 164, odds1: 79.00, probability: 1.13, template_id: null, created_at: null, updated_at: null },
  { id: 165, odds1: 80.00, probability: 1.12, template_id: null, created_at: null, updated_at: null },
  { id: 166, odds1: 81.00, probability: 1.1, template_id: null, created_at: null, updated_at: null },
  { id: 167, odds1: 82.00, probability: 1.09, template_id: null, created_at: null, updated_at: null },
  { id: 168, odds1: 83.00, probability: 1.08, template_id: null, created_at: null, updated_at: null },
  { id: 169, odds1: 84.00, probability: 1.07, template_id: null, created_at: null, updated_at: null },
  { id: 170, odds1: 85.00, probability: 1.06, template_id: null, created_at: null, updated_at: null },
  { id: 171, odds1: 86.00, probability: 1.05, template_id: null, created_at: null, updated_at: null },
  { id: 172, odds1: 87.00, probability: 1.04, template_id: null, created_at: null, updated_at: null },
  { id: 173, odds1: 88.00, probability: 1.03, template_id: null, created_at: null, updated_at: null },
  { id: 174, odds1: 90.00, probability: 1.02, template_id: null, created_at: null, updated_at: null },
  { id: 175, odds1: 93.00, probability: 1.01, template_id: null, created_at: null, updated_at: null },
  { id: 176, odds1: 94.00, probability: null, template_id: null, created_at: null, updated_at: null }
])

const searchQuery = ref('')

const filteredMilestones = computed(() => {
  const baseMilestones = searchQuery.value 
    ? milestones.value.filter(milestone => 
        milestone.id.toString().includes(searchQuery.value.toLowerCase()) ||
        milestone.odds1?.toString().includes(searchQuery.value.toLowerCase()) ||
        milestone.probability?.toString().includes(searchQuery.value.toLowerCase())
      )
    : milestones.value

  // If default template is selected, show all milestones without template_id
  if (selectedMilestoneType.value === 'default') {
    return baseMilestones.filter(milestone => !milestone.template_id)
  }
  
  // For other templates, show milestones with matching template_id
  return baseMilestones.filter(milestone => 
    milestone.template_id?.toLowerCase() === selectedMilestoneType.value
  )
})

// Add these refs and functions at the top of the script section
const editingCell = ref(null)
const editValue = ref('')

const startEditing = (item, field) => {
  editingCell.value = { item, field }
  editValue.value = item[field]?.toString() || ''
}

const saveEdit = (item) => {
  if (!editingCell.value) return

  const field = editingCell.value.field
  const value = editValue.value

  // Convert value based on field type
  let parsedValue = value
  if (field === 'probability') {
    parsedValue = parseFloat(value) || 0
  } else if (field === 'odds1' || field === 'odds2') {
    if (value.toLowerCase() === 'no offer') {
      parsedValue = "No Offer"
    } else {
      parsedValue = parseFloat(value) || 0
    }
  }

  // Update the item
  item[field] = parsedValue

  editingCell.value = null
  editValue.value = ''
}

const handleKeyDown = (e, milestone) => {
  if (e.key === 'Enter') {
    saveEdit(milestone)
  } else if (e.key === 'Escape') {
    editingCell.value = null
    editValue.value = ''
  }
}

const isEditing = (item, field) => {
  return editingCell.value?.item === item && editingCell.value?.field === field
}

// Add these refs at the top of the script section
const selectedMilestoneType = ref('default')
const milestoneTypes = ref([
  {
    id: 'default',
    name: 'Default Milestones',
    description: 'Standard milestone configuration',
    icon: 'fa-list',
    type: 'milestones'
  },
  {
    id: 'balanced-lines',
    name: 'Balanced Lines',
    description: 'Balanced odds and probabilities',
    icon: 'fa-balance-scale',
    type: 'milestones'
  },
  {
    id: 'aggressive',
    name: 'Aggressive Lines',
    description: 'Higher odds, lower probabilities',
    icon: 'fa-chart-line',
    type: 'milestones'
  },
  {
    id: 'conservative',
    name: 'Conservative Lines',
    description: 'Lower odds, higher probabilities',
    icon: 'fa-shield-alt',
    type: 'milestones'
  },
  {
    id: 'custom',
    name: 'Custom Lines',
    description: 'Custom milestone configuration',
    icon: 'fa-cog',
    type: 'milestones'
  }
])

// Update the balancedLines data structure
const balancedLines = ref({
  pairsList: [
    { probability: 0, odds1: "No Offer", odds2: "No Offer" },
    { probability: 1, odds1: 25.0, odds2: "No Offer" },
    { probability: 2, odds1: 20.0, odds2: "No Offer" },
    { probability: 3, odds1: 15.0, odds2: "No Offer" },
    { probability: 4, odds1: 12.0, odds2: 1.001 },
    { probability: 6, odds1: 10.0, odds2: 1.01 },
    { probability: 7, odds1: 9.0, odds2: 1.03 },
    { probability: 8, odds1: 8.0, odds2: 1.04 },
    { probability: 9, odds1: 7.5, odds2: 1.05 },
    { probability: 10, odds1: 7.0, odds2: 1.06 }
  ]
})

// Update the filteredBalancedLines computed property
const filteredBalancedLines = computed(() => {
  if (!searchQuery.value) return balancedLines.value.pairsList
  
  const query = searchQuery.value.toLowerCase()
  return balancedLines.value.pairsList.filter(line => 
    line.probability.toString().includes(query) ||
    line.odds1.toString().includes(query) ||
    line.odds2.toString().includes(query)
  )
})

// Update the addNewLine function for balanced lines
const addNewBalancedLine = () => {
  const newLine = {
    probability: null,
    odds1: null,
    odds2: null
  }
  
  balancedLines.value.pairsList.push(newLine)
}

// Add these refs and functions at the top of the script section
const editingTemplate = ref(null)
const newTemplateName = ref('')
const newTemplateDescription = ref('')
const showAddTemplate = ref(false)

const addNewTemplate = () => {
  if (!newTemplateName.value.trim()) return
  
  const newTemplate = {
    id: newTemplateName.value.toLowerCase().replace(/\s+/g, '-'),
    name: newTemplateName.value,
    description: newTemplateDescription.value,
    icon: 'fa-cog',
    type: 'milestones'
  }
  
  milestoneTypes.value.push(newTemplate)
  selectedMilestoneType.value = newTemplate.id // Make the new template active
  
  // Find the highest ID in existing milestones
  const maxId = Math.max(...milestones.value.map(m => m.id))
  
  // Add empty rows for the new template in milestones format
  const emptyRows = Array(10).fill().map((_, index) => ({
    id: maxId + index + 1, // Start from the next available ID
    odds1: null,
    probability: null,
    template_id: newTemplate.id.toUpperCase(),
    created_at: null,
    updated_at: null
  }))
  
  // Add new rows while preserving existing ones
  milestones.value = [...milestones.value, ...emptyRows]
  
  newTemplateName.value = ''
  newTemplateDescription.value = ''
  showAddTemplate.value = false
}

const startEditingTemplate = (template) => {
  editingTemplate.value = {
    id: template.id,
    name: template.name,
    description: template.description
  }
}

const saveTemplateEdit = (template) => {
  const index = milestoneTypes.value.findIndex(t => t.id === template.id)
  if (index !== -1) {
    milestoneTypes.value[index] = {
      ...milestoneTypes.value[index],
      name: editingTemplate.value.name,
      description: editingTemplate.value.description
    }
  }
  editingTemplate.value = null
}

const cancelTemplateEdit = () => {
  editingTemplate.value = null
}

// Add a computed property to filter lines by template
const filteredLinesByTemplate = computed(() => {
  if (!selectedMilestoneType.value) return []
  
  return balancedLines.value.pairsList.filter(line => 
    line.odds1.toString().includes(selectedMilestoneType.value) ||
    line.odds2.toString().includes(selectedMilestoneType.value) ||
    line.probability.toString().includes(selectedMilestoneType.value)
  )
})
</script>

<template>
  <div v-if="show" 
       class="fixed inset-0 bg-black/50 p-8 backdrop-blur-sm z-50 flex items-center justify-center"
       @click.self="$emit('close')"
  >
    <div class="w-full h-full max-w-[1400px] mx-auto flex">
      <div class="bg-white rounded-xl shadow-2xl w-full flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b shrink-0">
          <h2 class="text-xl font-semibold text-gray-800">Templates for Odds Ladders Management</h2>
          <button @click="$emit('close')" 
                  class="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Tabs -->
        <div class="border-b px-4 shrink-0">
          <div class="flex space-x-6">
            <button 
              v-for="tab in ['Balanced Lines', 'Milestones']" 
              :key="tab"
              @click="activeTab = tab.toLowerCase().replace(' ', '-')"
              :class="[
                'px-4 py-2 font-medium border-b-2 transition-colors',
                activeTab === tab.toLowerCase().replace(' ', '-')
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              ]"
            >
              {{ tab }}
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-hidden">
          <!-- Balanced Lines Tab -->
          <div v-if="activeTab === 'balanced-lines'" class="h-full flex">
            <!-- Left Side Panel -->
            <div class="w-64 border-r bg-gray-50 flex flex-col">
              <div class="p-4 border-b">
                <h3 class="font-medium text-gray-700 mb-2">Balanced Lines Types</h3>
                <div class="relative">
                  <input 
                    type="text" 
                    placeholder="Search types..."
                    class="w-full pl-8 pr-4 py-1.5 text-sm border rounded-lg"
                  >
                  <i class="fas fa-search absolute left-2.5 top-2.5 text-gray-400 text-sm"></i>
                </div>
              </div>
              
              <div class="flex-1 overflow-y-auto">
                <div 
                  v-for="type in milestoneTypes" 
                  :key="type.id"
                  @click="selectedMilestoneType = type.id"
                  class="p-4 border-b cursor-pointer transition-colors"
                  :class="[
                    selectedMilestoneType === type.id 
                      ? 'bg-blue-50 border-blue-200' 
                      : 'hover:bg-gray-100'
                  ]"
                >
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                      <i :class="['fas', type.icon, 'text-gray-600']"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                      <template v-if="editingTemplate?.id === type.id">
                        <input
                          v-model="editingTemplate.name"
                          type="text"
                          class="w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 mb-1"
                          @keydown.enter="saveTemplateEdit(type)"
                          @keydown.esc="cancelTemplateEdit"
                          @blur="saveTemplateEdit(type)"
                          ref="editInput"
                          @focus="$event.target.select()"
                        >
                        <input
                          v-model="editingTemplate.description"
                          type="text"
                          class="w-full px-2 py-1 text-xs border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          @keydown.enter="saveTemplateEdit(type)"
                          @keydown.esc="cancelTemplateEdit"
                          @blur="saveTemplateEdit(type)"
                        >
                      </template>
                      <template v-else>
                        <div class="font-medium text-gray-700 truncate" @dblclick="startEditingTemplate(type)">
                          {{ type.name }}
                        </div>
                        <div class="text-xs text-gray-500 truncate" @dblclick="startEditingTemplate(type)">
                          {{ type.description }}
                        </div>
                      </template>
                    </div>
                    <button 
                      v-if="type.id !== 'default'"
                      @click.stop="startEditingTemplate(type)"
                      class="p-1 text-gray-400 hover:text-gray-600"
                    >
                      <i class="fas fa-edit text-xs"></i>
                    </button>
                  </div>
                </div>

                <!-- Add New Template Form -->
                <div v-if="showAddTemplate" class="p-4 border-b">
                  <div class="space-y-2">
                    <input
                      v-model="newTemplateName"
                      type="text"
                      placeholder="Template name"
                      class="w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @keydown.enter="addNewTemplate"
                    >
                    <input
                      v-model="newTemplateDescription"
                      type="text"
                      placeholder="Template description"
                      class="w-full px-2 py-1 text-xs border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @keydown.enter="addNewTemplate"
                    >
                    <div class="flex gap-2">
                      <button 
                        @click="addNewTemplate"
                        class="flex-1 px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
                      >
                        Add
                      </button>
                      <button 
                        @click="showAddTemplate = false"
                        class="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-4 border-t">
                <button 
                  @click="showAddTemplate = true"
                  class="w-full px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
                >
                  <i class="fas fa-plus"></i>
                  Add New Type
                </button>
              </div>
            </div>

            <!-- Right Content Area -->
            <div class="flex-1 flex flex-col">
              <!-- Search and Actions -->
              <div class="flex justify-between items-center p-4 shrink-0 bg-white border-b">
                <div class="flex gap-4">
                  <div class="relative">
                    <input 
                      v-model="searchQuery"
                      type="text" 
                      placeholder="Search lines..."
                      class="pl-8 pr-4 py-1.5 text-sm border rounded-lg"
                    >
                    <i class="fas fa-search absolute left-2.5 top-2.5 text-gray-400 text-sm"></i>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button class="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-2">
                    <i class="fas fa-download"></i>
                    Export
                  </button>
                  <button 
                    @click="addNewBalancedLine"
                    class="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                  >
                    <i class="fas fa-plus"></i>
                    Add Line
                  </button>
                </div>
              </div>

              <!-- Balanced Lines Table -->
              <div class="flex-1 overflow-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50 sticky top-0 z-10">
                    <tr>
                      <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Probability</th>
                      <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Odds 1</th>
                      <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Odds 2</th>
                      <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="line in filteredBalancedLines" 
                        :key="line.probability"
                        class="hover:bg-gray-50"
                    >
                      <td 
                        class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                        @click="startEditing(line, 'probability')"
                      >
                        <template v-if="!isEditing(line, 'probability')">
                          {{ line.probability !== null ? line.probability.toFixed(1) : '-' }}
                        </template>
                        <input
                          v-else
                          v-model="editValue"
                          type="number"
                          step="0.1"
                          class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          @keydown="(e) => handleKeyDown(e, line)"
                          @blur="saveEdit(line)"
                          ref="editInput"
                          @focus="$event.target.select()"
                        >
                      </td>
                      <td 
                        class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                        @click="startEditing(line, 'odds1')"
                      >
                        <template v-if="!isEditing(line, 'odds1')">
                          {{ line.odds1 === "No Offer" ? "No Offer" : (line.odds1 !== null ? line.odds1.toFixed(2) : '-') }}
                        </template>
                        <input
                          v-else
                          v-model="editValue"
                          :type="editValue.toLowerCase() === 'no offer' ? 'text' : 'number'"
                          step="0.01"
                          class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          @keydown="(e) => handleKeyDown(e, line)"
                          @blur="saveEdit(line)"
                          ref="editInput"
                          @focus="$event.target.select()"
                        >
                      </td>
                      <td 
                        class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                        @click="startEditing(line, 'odds2')"
                      >
                        <template v-if="!isEditing(line, 'odds2')">
                          {{ line.odds2 === "No Offer" ? "No Offer" : (line.odds2 !== null ? line.odds2.toFixed(2) : '-') }}
                        </template>
                        <input
                          v-else
                          v-model="editValue"
                          :type="editValue.toLowerCase() === 'no offer' ? 'text' : 'number'"
                          step="0.01"
                          class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          @keydown="(e) => handleKeyDown(e, line)"
                          @blur="saveEdit(line)"
                          ref="editInput"
                          @focus="$event.target.select()"
                        >
                      </td>
                      <td class="px-4 py-2 whitespace-nowrap text-right text-sm font-medium">
                        <button class="text-blue-600 hover:text-blue-900 mr-2">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="text-red-600 hover:text-red-900">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Milestones Tab -->
          <div v-if="activeTab === 'milestones'" class="h-full flex">
            <!-- Left Side Panel -->
            <div class="w-64 border-r bg-gray-50 flex flex-col">
              <div class="p-4 border-b">
                <h3 class="font-medium text-gray-700 mb-2">Milestone Ladder Types</h3>
                <div class="relative">
                  <input 
                    type="text" 
                    placeholder="Search types..."
                    class="w-full pl-8 pr-4 py-1.5 text-sm border rounded-lg"
                  >
                  <i class="fas fa-search absolute left-2.5 top-2.5 text-gray-400 text-sm"></i>
                </div>
              </div>
              
              <div class="flex-1 overflow-y-auto">
                <div 
                  v-for="type in milestoneTypes" 
                  :key="type.id"
                  @click="selectedMilestoneType = type.id"
                  class="p-4 border-b cursor-pointer transition-colors"
                  :class="[
                    selectedMilestoneType === type.id 
                      ? 'bg-blue-50 border-blue-200' 
                      : 'hover:bg-gray-100'
                  ]"
                >
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                      <i :class="['fas', type.icon, 'text-gray-600']"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                      <template v-if="editingTemplate?.id === type.id">
                        <input
                          v-model="editingTemplate.name"
                          type="text"
                          class="w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 mb-1"
                          @keydown.enter="saveTemplateEdit(type)"
                          @keydown.esc="cancelTemplateEdit"
                          @blur="saveTemplateEdit(type)"
                          ref="editInput"
                          @focus="$event.target.select()"
                        >
                        <input
                          v-model="editingTemplate.description"
                          type="text"
                          class="w-full px-2 py-1 text-xs border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                          @keydown.enter="saveTemplateEdit(type)"
                          @keydown.esc="cancelTemplateEdit"
                          @blur="saveTemplateEdit(type)"
                        >
                      </template>
                      <template v-else>
                        <div class="font-medium text-gray-700 truncate" @dblclick="startEditingTemplate(type)">
                          {{ type.name }}
                        </div>
                        <div class="text-xs text-gray-500 truncate" @dblclick="startEditingTemplate(type)">
                          {{ type.description }}
                        </div>
                      </template>
                    </div>
                    <button 
                      v-if="type.id !== 'default'"
                      @click.stop="startEditingTemplate(type)"
                      class="p-1 text-gray-400 hover:text-gray-600"
                    >
                      <i class="fas fa-edit text-xs"></i>
                    </button>
                  </div>
                </div>

                <!-- Add New Template Form -->
                <div v-if="showAddTemplate" class="p-4 border-b">
                  <div class="space-y-2">
                    <input
                      v-model="newTemplateName"
                      type="text"
                      placeholder="Template name"
                      class="w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @keydown.enter="addNewTemplate"
                    >
                    <input
                      v-model="newTemplateDescription"
                      type="text"
                      placeholder="Template description"
                      class="w-full px-2 py-1 text-xs border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      @keydown.enter="addNewTemplate"
                    >
                    <div class="flex gap-2">
                      <button 
                        @click="addNewTemplate"
                        class="flex-1 px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
                      >
                        Add
                      </button>
                      <button 
                        @click="showAddTemplate = false"
                        class="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-4 border-t">
                <button 
                  @click="showAddTemplate = true"
                  class="w-full px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
                >
                  <i class="fas fa-plus"></i>
                  Add New Type
                </button>
              </div>
            </div>

            <!-- Right Content Area -->
            <div class="flex-1 flex flex-col">
              <!-- Search and Actions -->
              <div class="flex justify-between items-center p-4 shrink-0 bg-white border-b">
                <div class="flex gap-4">
                  <div class="relative">
                    <input 
                      v-model="searchQuery"
                      type="text" 
                      :placeholder="`Search ${selectedMilestoneType.includes('lines') ? 'lines' : 'milestones'}...`"
                      class="pl-8 pr-4 py-1.5 text-sm border rounded-lg"
                    >
                    <i class="fas fa-search absolute left-2.5 top-2.5 text-gray-400 text-sm"></i>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button class="px-3 py-1.5 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-2">
                    <i class="fas fa-download"></i>
                    Export
                  </button>
                  <button 
                    @click="addNewBalancedLine"
                    class="px-3 py-1.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                  >
                    <i class="fas fa-plus"></i>
                    Add {{ selectedMilestoneType.includes('lines') ? 'Line' : 'Milestone' }}
                  </button>
                </div>
              </div>

              <!-- Content based on selected type -->
              <div class="flex-1 overflow-hidden">
                <div class="h-full overflow-auto">
                  <!-- Milestones Table -->
                  <table v-if="!selectedMilestoneType.includes('lines')" class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50 sticky top-0 z-10">
                      <tr>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">ID</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Odds</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Probability</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Template ID</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Created At</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Updated At</th>
                        <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="milestone in filteredMilestones" 
                          :key="milestone.id"
                          class="hover:bg-gray-50"
                      >
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
                          {{ milestone.id }}
                        </td>
                        <td 
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                          @click="startEditing(milestone, 'odds1')"
                        >
                          <template v-if="!isEditing(milestone, 'odds1')">
                            {{ milestone.odds1 !== null ? milestone.odds1.toFixed(2) : '-' }}
                          </template>
                          <input
                            v-else
                            v-model="editValue"
                            type="number"
                            step="0.01"
                            class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            @keydown="(e) => handleKeyDown(e, milestone)"
                            @blur="saveEdit(milestone)"
                            ref="editInput"
                            @focus="$event.target.select()"
                          >
                        </td>
                        <td 
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                          @click="startEditing(milestone, 'probability')"
                        >
                          <template v-if="!isEditing(milestone, 'probability')">
                            {{ milestone.probability !== null ? `${milestone.probability.toFixed(1)}%` : 'No Offer' }}
                          </template>
                          <input
                            v-else
                            v-model="editValue"
                            :type="editValue.toLowerCase() === 'no offer' ? 'text' : 'number'"
                            step="0.1"
                            class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            @keydown="(e) => handleKeyDown(e, milestone)"
                            @blur="saveEdit(milestone)"
                            ref="editInput"
                            @focus="$event.target.select()"
                          >
                        </td>
                        <td 
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                          @click="startEditing(milestone, 'template_id')"
                        >
                          <template v-if="!isEditing(milestone, 'template_id')">
                            {{ milestone.template_id || '-' }}
                          </template>
                          <input
                            v-else
                            v-model="editValue"
                            type="text"
                            class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            @keydown="(e) => handleKeyDown(e, milestone)"
                            @blur="saveEdit(milestone)"
                            ref="editInput"
                            @focus="$event.target.select()"
                          >
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                          {{ milestone.created_at || '-' }}
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                          {{ milestone.updated_at || '-' }}
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-right text-sm font-medium">
                          <button class="text-blue-600 hover:text-blue-900 mr-2">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="text-red-600 hover:text-red-900">
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Balanced Lines Table -->
                  <table v-else class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50 sticky top-0 z-10">
                      <tr>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Odds</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Probability</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Template ID</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Updated At</th>
                        <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="line in filteredLinesByTemplate" 
                          :key="line.probability"
                          class="hover:bg-gray-50"
                      >
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
                          {{ line.probability }}
                        </td>
                        <td 
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                          @click="startEditing(line, 'odds1')"
                        >
                          <template v-if="!isEditing(line, 'odds1')">
                            {{ line.odds1 === "No Offer" ? "No Offer" : (line.odds1 !== null ? line.odds1.toFixed(2) : '-') }}
                          </template>
                          <input
                            v-else
                            v-model="editValue"
                            type="number"
                            step="0.01"
                            class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            @keydown="(e) => handleKeyDown(e, line)"
                            @blur="saveEdit(line)"
                            ref="editInput"
                            @focus="$event.target.select()"
                          >
                        </td>
                        <td 
                          class="px-4 py-2 whitespace-nowrap text-sm text-gray-900 cursor-pointer"
                          @click="startEditing(line, 'probability')"
                        >
                          <template v-if="!isEditing(line, 'probability')">
                            {{ line.probability !== null ? line.probability.toFixed(1) : '-' }}
                          </template>
                          <input
                            v-else
                            v-model="editValue"
                            type="number"
                            step="0.1"
                            class="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            @keydown="(e) => handleKeyDown(e, line)"
                            @blur="saveEdit(line)"
                            ref="editInput"
                            @focus="$event.target.select()"
                          >
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                          {{ line.odds2 === "No Offer" ? "No Offer" : (line.odds2 !== null ? line.odds2.toFixed(2) : '-') }}
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                          {{ line.created_at }}
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
                          {{ line.updated_at }}
                        </td>
                        <td class="px-4 py-2 whitespace-nowrap text-right text-sm font-medium">
                          <button class="text-blue-600 hover:text-blue-900 mr-2">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="text-red-600 hover:text-red-900">
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Add styles for editable cells */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

td {
  position: relative;
}

td input {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border: 2px solid #3b82f6;
  padding: 0.5rem 1rem;
  background: white;
}

/* Add styles for the left panel */
.w-64 {
  width: 16rem;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.border-r {
  border-right: 1px solid #e5e7eb;
}

.border-b {
  border-bottom: 1px solid #e5e7eb;
}

.border-t {
  border-top: 1px solid #e5e7eb;
}

/* Ensure the table takes full height of its container */
.h-full {
  height: 100%;
}

/* Add smooth transitions for hover and selection states */
.transition-colors {
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Add styles for template editing */
input[type="text"] {
  min-width: 0;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.min-w-0 {
  min-width: 0;
}
</style> 